import { FC, memo } from "react";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import FolderOffIcon from "@mui/icons-material/FolderOff";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { EmptyState } from "@/components/ui/EmptyState";

/**
 * Empty state shown when search returns no results.
 */
export const SegmentsSearchEmptyState: FC = memo(
  function SegmentsSearchEmptyState() {
    return (
      <EmptyState
        icon={SearchOffIcon}
        title="No segments found"
        description="No segments match your search. Try a different search term."
      />
    );
  }
);

/**
 * Empty state shown when no segments have been created yet.
 */
export const SegmentsEmptyState: FC = memo(function SegmentsEmptyState() {
  return (
    <EmptyState
      icon={FolderOffIcon}
      title="No segments yet"
      description="Create your first segment to start organizing and targeting companies."
    />
  );
});

/**
 * Error state shown when segment fetching fails.
 */
export const SegmentsErrorState: FC = memo(function SegmentsErrorState() {
  return (
    <EmptyState
      icon={ErrorOutlineIcon}
      title="Unable to load segments"
      description="Something went wrong while fetching your segments. Please try again or contact support if the problem persists."
      variant="error"
    />
  );
});
